<form (submit)="submit()" novalidate>
  <formly-validation-message></formly-validation-message>
  <formly-form [model]="form.model" [fields]="form.fields" [form]="form.form" [options]="options">
    <div *ngIf="captcha" class="row" style="margin-bottom: 20px">
      <div class="col-md-12">
        Podaj liczbę będącą wynikiem wyrażenia:
        <span class="captcha" [innerHTML]="captcha.captcha"></span>
        <button class="btn btn-light" title="Pobierz inne działanie" (click)="getCaptcha()"><i
            class="fas fa-sync-alt"></i></button>
        <br />

        Wynik (jako liczba): <input name="captchaOdpowiedz" [(ngModel)]="captcha.odpowiedz" class="form-control" />
      </div>
    </div>
    <button type="submit" class="btn btn-block btn-lg custom-button"><fa-icon icon="paper-plane"></fa-icon> Wyślij</button>
  </formly-form>
</form>
<div class="alert alert-danger mt-3" role="alert" *ngIf="showError()">Nie wszystkie obowiązkowe pola zostały
  wypełnione!</div>
<div class="alert alert-danger mt-3" role="alert" *ngIf="brakCaptcha">Nie wypełniono wyniku działania!</div>
<div class="alert alert-danger mt-3" role="alert" *ngIf="errorMessage">{{errorMessage}}</div>
<div *ngIf="showSendingAlert" class="alert alert-warning mt-3" role="alert">
  Trwa wysyłanie wiadomości...
</div>
<div *ngIf="showSuccesAlert" class="alert alert-success mt-3" role="alert">
  Twoja wiadomość została wysłana.
</div>
